import { GetTogglesRequest } from '@eggplant/api-requests'
import { UpmReportingContextConsumer } from '@eggplant/context'
import {
  Icons,
  NavGroup,
  NavItemVertical
} from '@eggplant/pattern-library'
import {
  CONTROLLER,
  DASHBOARDS,
  DESIGNER,
  INSIGHTS,
  LinkToStudio,
  MONITOR,
  SPACE_DETAILS,
  STUDIO,
  routeLabels
} from '@eggplant/routing'
import type { TogglesResponse } from '@eggplant/types'
import { Match } from '@reach/router'
import type { ReactNode } from 'react'
import {
  FaCode,
  FaPlayCircle
} from 'react-icons/fa'
import ControllerNav from './ControllerNav'
import DashboardsNav from './DashboardsNav'
import DesignerNav from './DesignerNav'
import InsightsNav from './InsightsNav'
import MonitorNav from './MonitorNav'
import SpacesNavGroup from './SpacesNavGroup'

interface Props {
  isCollapsed: boolean
}

const WILDCARD = '/*'

// The "key"s reset the NavGroup state on every route change.

const Top = ({
  isCollapsed
}: Props) => (
  <>
    <SpacesNavGroup
      base={SPACE_DETAILS}
      isCollapsed={isCollapsed}
    />
    <Match path={'/' + DASHBOARDS + WILDCARD}>
      {
        ({
          match
        }) =>
          <NavGroup
            icon={<Icons.Rocket aria-hidden />}
            isCollapsed={isCollapsed}
            isCurrent={!!match}
            label='Dashboard'
          >
            <DashboardsNav
              base={DASHBOARDS}
              isCollapsed={isCollapsed}
            />
          </NavGroup>
      }
    </Match>
    <Match path={'/' + DESIGNER + WILDCARD}>
      {
        ({
          match
        }) =>
          <NavGroup
            icon={<Icons.Designer aria-hidden />}
            isCollapsed={isCollapsed}
            isCurrent={!!match}
            label='Designer'
          >
            <DesignerNav
              base={DESIGNER}
              isCollapsed={isCollapsed}
            />
          </NavGroup>
      }
    </Match>
    <Match path={'/' + CONTROLLER + WILDCARD}>
      {
        ({
          match
        }) =>
          <NavGroup
            icon={<FaPlayCircle aria-hidden />}
            isCollapsed={isCollapsed}
            isCurrent={!!match}
            label='Controller'
          >
            <ControllerNav
              base={CONTROLLER}
              isCollapsed={isCollapsed}
            />
          </NavGroup>
      }
    </Match>
    <Match path={'/' + INSIGHTS + WILDCARD}>
      {
        ({
          match
        }) =>
          <NavGroup
            icon={<Icons.Insights aria-hidden />}
            isCollapsed={isCollapsed}
            isCurrent={!!match}
            label='Insights'
          >
            <InsightsNav
              base={INSIGHTS}
              isCollapsed={isCollapsed}
            />
          </NavGroup>
      }
    </Match>
    <UpmReportingContextConsumer>
      {
        ({ isUpmReportingEnabled }) =>
          isUpmReportingEnabled &&
            <Match path={'/' + MONITOR + WILDCARD}>
              {
                ({
                  match
                }) =>
                  <NavGroup
                    icon={<Icons.Monitor />}
                    isCollapsed={isCollapsed}
                    isCurrent={!!match}
                    label='Monitor'
                  >
                    <MonitorNav
                      base={MONITOR}
                      isCollapsed={isCollapsed}
                    />
                  </NavGroup>
              }
            </Match>
      }
    </UpmReportingContextConsumer>
    <GetTogglesRequest>
      {
        (
          {
            deployment_flags
          }: TogglesResponse
        ) =>
          deployment_flags.ENABLE_HOSTED_STUDIO &&
            <NavItemVertical
              icon={<FaCode aria-hidden />}
              isCollapsed={isCollapsed}
              label={routeLabels[STUDIO]}
            >
              {
                (content: ReactNode) =>
                  <LinkToStudio>
                    {content}
                  </LinkToStudio>
              }
            </NavItemVertical>
      }
    </GetTogglesRequest>
  </>
)

export default Top
